'use client';
import React, { useEffect, useRef } from 'react';

const certifications = [
    {
      code: 'Pelatihan',
      name: 'Edukasi & Pengembangan SDM Pertanian'
    },
    {
      code: 'Smart Farming',
      name: 'Pengembangan Infrastruktur Smart Farming'
    },
    {
      code: 'Analisa Data',
      name: 'Akuisisi, Analitik & Prakiraan Data Pertanian'
    },
    {
      code: 'Agri Command Center',
      name: 'Pusat Data & Pengendalian Agrikultur'
    }
  ];

const operationStats = [
  { label: 'Titik Hotspot', value: '22', sub: 'titik pertanian terintegrasi' },
  { label: 'Lokasi', value: 'Kaltim', sub: 'Kalimantan Timur, Indonesia' },
  { label: 'Tahun Berdiri', value: '2025', sub: 'perusahaan teknologi pertanian' },
  { label: 'Platform SaaS', value: '1', sub: 'sistem pertanian cerdas' },
  { label: 'LMS', value: '1', sub: 'platform edukasi terbuka' },
  { label: 'Ekosistem', value: 'Terbuka', sub: 'petani · pengembang · komunitas' },
];

export default function OperationsSection() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );
    const els = ref?.current?.querySelectorAll('.reveal, .reveal-left, .reveal-right');
    els?.forEach((el) => observer?.observe(el));
    return () => observer?.disconnect();
  }, []);

  return (
    <section id="operations" ref={ref} className="relative bg-canopy blueprint-grid py-24 md:py-32 px-6 md:px-10">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-end mb-16">
          <div>
            <div className="reveal flex items-center gap-4 mb-4">
              <div className="w-12 h-px bg-chartreuse opacity-60" />
              <span className="annotation">KOMITMEN PERUSAHAAN · 2026</span>
            </div>
            <h2 className="reveal delay-100 font-mono font-bold text-4xl md:text-5xl text-text-primary leading-tight">
              MASA DEPAN<br />
              <span className="text-chartreuse">PERTANIAN INDONESIA</span>
            </h2>
          </div>
          <p className="reveal delay-200 text-text-muted text-lg leading-relaxed">
            Kami berkomitmen untuk mendukung program pemerintah dan membangun masa depan pertanian Indonesia.
          </p>
        </div>
        {/* <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-12">
          {operationStats.map((stat, i) => (
            <div
              key={stat.label}
              className={`reveal delay-${(i % 4) * 100} ${
                i === 0 || i === 3 ? 'col-span-2' : 'col-span-1'
              } border border-chartreuse/15 rounded-sm p-6 bg-pond/50 group hover:border-chartreuse/40 transition-colors duration-300`}
            >
              <div className="font-mono font-black text-chartreuse text-2xl md:text-3xl mb-1 leading-none">
                {stat.value}
              </div>
              <div className="font-mono text-text-primary text-xs font-semibold tracking-wide mb-1">
                {stat.label}
              </div>
              <div className="annotation text-text-muted/50">{stat.sub}</div>
            </div>
          ))}
        </div> */}
        <div className="reveal border border-chartreuse/15 rounded-sm p-8 bg-pond/30">
          <div className="annotation mb-6">PETA JALAN</div>
          <div className="flex flex-wrap gap-4 max-w-full">
            {certifications.map((cert) => (
              <div
                key={cert.code}
                className="flex items-center w-full lg:max-w-1/4 gap-3 border border-chartreuse/20 rounded-sm px-4 py-3 bg-canopy/50 hover:border-chartreuse/50 transition-colors group"
              >
                <div className="w-2 h-2 rounded-full bg-chartreuse group-hover:animate-pulse" />
                <div>
                  <div className="font-mono font-bold text-chartreuse text-sm">{cert.code}</div>
                  <div className="annotation text-text-muted/60">{cert.name}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="absolute bottom-0 left-0 right-0 rule-line" />
    </section>
  );
}
